<div class="container description-dialog">
    <button
        [mat-dialog-close]="true"
        class="dialog-close-button"
        disableRipple
        mat-icon-button
    >
        <mat-icon>close</mat-icon>
    </button>
    <div class="m-t-negative-15">
        <h3>{{ title }}</h3>
        <p>{{ description }}</p>
    </div>
</div>
